import React, { FC } from 'react';
import { ReactComponent as HistoryIcon } from 'app/assets/images/redesign/history.svg';
import { ReactComponent as CompletedIcon } from 'app/assets/images/redesign/completed.svg';
import { ReactComponent as DeliveryIcon } from 'app/assets/images/redesign/delivery.svg';
import { ReactComponent as CancelledIcon } from 'app/assets/images/redesign/cancelled.svg';
import { getSupplyStatus } from 'entities/Supply/Supply.helper';
import { ESupplyStatus, ESupplyStatusLabel } from 'entities/Supply/Supply.enum';

interface IComponentProps {
  status: string;
  isCancelledBySeller?: boolean;
}

export const SupplyStatus: FC<IComponentProps> = ({ status, isCancelledBySeller }) => {
  const {
    isCreatedSupply,
    isPendingSupply,
    isProcessingSupply,
    isApprovedSupply,
    isDeliverySupply,
    isDeliveredSupply,
    isCancelledSupply,
  } = getSupplyStatus(status);

  const getStatusIcon = () => {
    switch (true) {
      case isCreatedSupply: {
        return <HistoryIcon className="icon-history-dark-grey" />;
      }
      case isPendingSupply: {
        return <CompletedIcon className="icon-completed-bright-green" />;
      }
      case isProcessingSupply: {
        return <DeliveryIcon className="icon-delivery-dark-grey" />;
      }
      case isApprovedSupply:
      case isDeliverySupply: {
        return <DeliveryIcon className="icon-delivery-yellow" />;
      }
      case isDeliveredSupply: {
        return <DeliveryIcon className="icon-delivery-bright-green" />;
      }
      case isCancelledSupply: {
        return <CancelledIcon className="icon-cancelled-red" />;
      }
      default: {
        return null;
      }
    }
  };

  const getStatusLabel = () => {
    if (isCancelledSupply && isCancelledBySeller) {
      return 'Отказ поставщика';
    }

    return ESupplyStatusLabel[status as ESupplyStatus];
  };

  return (
    <div className="supply-status">
      {getStatusIcon()}

      <span className="text-tag-accent">{getStatusLabel()}</span>
    </div>
  );
};
